export var TILE_PER_ROW_MOBILE = 1;
export var TILE_PER_ROW_TABLET = 2;
export var TILE_PER_ROW_DESKTOP = 3;
